

<style lang="scss">

.ivu-drawer-body{
    padding: 0 !important;
    margin: 0;
}
.tabs{
    display: flex;
    .tab{
        width: 50%;
        text-align: center;
        margin-bottom: 25px;
        background: #dededd;
        &:first-child{
            border-right: 0;
        }
        padding: 10px 0;
        border: 1px solid #606060;
        &.act{
            border-color:#2d8cf0;
            background:#2d8cf0;
            color: #fff;
        }
        cursor: pointer;
    }
}
span.tip{
    color: #838383;
}
.tip{
    text-align: center;
}
</style>
<template>
    <Drawer
        :width="450"
        :mask-closable="false" 
        v-model="show"
    >
        <div class="tabs">
            <div :class="{act : type == 2}" class="tab" @click="type = 2">注册</div>
            <div :class="{act : type == 1}" class="tab" @click="type = 1">登陆</div>
        </div>
        <Form v-if="type == 1" style="padding:20px" ref="loginForm" :model="formData" :rules="rules" label-position="top">
            <FormItem label="邮箱 或 用户名" prop="account">
                <Input v-model="formData.account" placeholder="请输入您注册的邮箱,用户名"></Input>
            </FormItem>
            <FormItem label="密码" prop="password">
                <Input v-model="formData.password" placeholder="请输入密码" type="password" password></Input>
            </FormItem>
            <FormItem style="text-align: right;" >
                <div style="text-align: right;"><a @click="openModal()" >忘记密码?</a></div>
            </FormItem>
            <FormItem >
                <Button @click="login" :loading="loading"  long type="primary" size="large">登陆</Button>
            </FormItem>
            <Divider />
            <div class="tip">
                登录即代表同意 <a @click="showa">服务条款</a> 和 <a @click="showb">用户协议</a>
            </div>
            
        </Form>
        <Form v-if="type == 2" style="padding:20px" ref="registerForm" :model="formData2" :rules="rules2" label-position="top">
            <FormItem label="昵称" prop="nickname">
                <Input v-model="formData2.nickname" placeholder="请输入昵称"></Input>
            </FormItem>
            <FormItem label="用户名" prop="username">
                <Input v-model="formData2.username" placeholder="必须是字母开头,不允许包含特殊符号"></Input>
            </FormItem>
            <FormItem label="邮箱" prop="account">
                <Input v-model="formData2.account" placeholder="请输入您注册的邮箱"></Input>
                <span class="tip">"用户名" 和 "邮箱" 都可以用于登陆</span>
            </FormItem>
            <FormItem label="验证码" prop="vcode">
                <Input style="width:60%;" v-model="formData2.vcode" placeholder="请输入验证码"></Input>
                <Button 
                    style="width:35%;float:right" @click="sendVCode(formData2.account)"
                    :disabled="!formData2.account || sending > 1 || disabledSendVCode"
                >
                    {{sending > 1 ? ""+sending+"秒后再次发送" : '点击获取验证码'}}
                </Button>
            </FormItem>
            <FormItem label="密码" prop="password">
                <Input v-model="formData2.password" placeholder="请设置登录密码" type="password" password></Input>
            </FormItem>
            <FormItem label="再次输入密码" prop="password2">
                <Input v-model="formData2.password2" placeholder="请设置登录密码" type="password" password></Input>
            </FormItem>
            
            
            <FormItem >
                <Button @click="register" :loading="loading" long type="primary" size="large">注册</Button>
            </FormItem>
            
        </Form>
        <Modal v-model="modal.show" title="找回密码" :width="800">
            <Steps :current="modal.current">
                <Step title="验证账号" icon="ios-person"></Step>
                <Step title="设置新密码" icon="ios-lock"></Step>
                <Step title="修改成功" icon="ios-checkmark-circle-outline"></Step>
            </Steps>
            <Form style="padding:20px" ref="resetPwdForm" :model="modal.formData" :rules="modal.rules" label-position="top"  v-if="modal.current < 2">
                <FormItem label="请输入邮箱 或 用户名" prop="accountOrEmail">
                    <Input :disabled="modal.current !== 0" v-model="modal.formData.accountOrEmail" placeholder="请输入您注册的邮箱,用户名"></Input>
                </FormItem>
                <FormItem label="密码" prop="password" v-if="modal.current == 1">
                    <Input v-model="modal.formData.password" placeholder="请设置新的登录密码" type="password" password></Input>
                </FormItem>
                <FormItem label="再次输入密码" prop="password2" v-if="modal.current == 1">
                    <Input v-model="modal.formData.password2" placeholder="请设置新的登录密码" type="password" password></Input>
                </FormItem>
                <FormItem label="请输入验证码" prop="vcode" v-if="modal.current == 1">
                    <div>
                        <Alert>已向您的邮箱: {{modal.formData.email}} 发送验证码,请注意查收</Alert>
                    </div>
                    <Input style="width:70%;" v-model="modal.formData.vcode" placeholder="请输入验证码"></Input>
                    <Button 
                        style="width:25%;float:right" @click="sendVCode(modal.formData.email)"
                        :disabled="modal.formData.account || sending > 1"
                    >
                        {{sending > 1 ? ""+sending+"秒后再次发送" : '点击获取验证码'}}
                    </Button>
                </FormItem>
                
            </Form>
            <div v-else style="text-align:center;padding:25px">
                <Icon type="ios-checkmark-circle" size="200" color="green"/>
                <div>操作成功,请重新登陆</div>
            </div>
            <template #footer>
                <div style="text-align:right">
                    <Button v-if="modal.current == 1" @click="per()" :loading="loading" type="default" size="large" style="margin-right:15px;">上一步</Button>
                    <Button v-if="modal.current < 2" @click="next()" :loading="loading" type="primary" size="large" >下一步</Button>
                    <Button v-if="modal.current == 2" @click="modal.show = false" :loading="loading" type="primary" size="large" >关闭</Button>
                </div>
            </template>
        </Modal>
        <UserOKServiceModal ref="UserOKServiceModalRef" />
        <UserOKPrivateModal ref="UserOKPrivateModalRef" />
    </Drawer>
</template>

<script>
    import UserOKServiceModal from "./UserOKServiceModal.vue"
    import UserOKPrivateModal from "./UserOKPrivateModal.vue"

    import loginService from "@/service/login/index"
    import userService from "@/service/user/index"
    export default {
        name: 'LoginDrawer',
        components:{UserOKServiceModal,UserOKPrivateModal},
        emits:["on-login-success"],
        data() {
            const that = this;
            return {
                show : false,
                modal: {
                    show: false,
                    current: 0,
                    formData: {},
                    rules: {
                        accountOrEmail: [
                            { required: true, message: '请输入用户名或者邮箱', trigger: 'blur' },
                            { type: 'string', min: 2, message: '至少输入2位', trigger: 'blur' },
                            { validator: async (rule, value, callback) => {
                                if(this.modal.current == 0){
                                    this.loading = true;
                                    let result = await loginService.findEmail(value);
                                    this.loading = false;
                                    if(!result){
                                        callback(new Error('该账户未注册'));
                                        return;
                                    }
                                    that.disabledSendVCode = false;
                                    that.modal.formData.email = result;
                                }
                                callback();
                            }, trigger: 'blur' }
                        ],
                        password: [
                            { required: true, message: '请输入密码', trigger: 'blur' },
                            { type: 'string', min: 6, message: '密码至少输入6位', trigger: 'blur' }
                        ],
                        password2: [
                            { required: true, message: '请在此输入密码', trigger: 'blur' },
                            { validator: (rule, value, callback) => {
                                if(this.modal.formData.password !== value){
                                    callback(new Error('两次密码不一致'));
                                    return;
                                }
                                callback();
                            }, trigger: 'blur' }
                        ],
                        vcode: [
                            { required: true, message: '请输入验证码', trigger: 'blur' },
                        ],
                    }
                },
                type : 1,
                rules: {
                    account: [
                        { required: true, message: '请输入邮箱', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                },
                formData: {
                    account:"",
                    password:"",
                },
                rules2: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { type: 'string', min: 2, message: '用户名至少输入2位', trigger: 'blur' },
                        { type: 'string', max: 32, message: '用户名最多输入32位', trigger: 'blur' },
                        { validator: async (rule, value, callback) => {
                            var reg = new RegExp("^[A-Za-z0-9\u4e00-\u9fa5]+$");
                            let result = reg.test(value);
                            if(!result){
                                callback(new Error('请输入正确的用户名. 只能包含数字,字母,中文'));
                                return;
                            }
                            result = await loginService.checkUsername(value);
                            if(!result){
                                callback(new Error('用户名已被占用'));
                                return;
                            }
                            callback();
                        }, trigger: 'blur' }
                    ],
                    account: [
                        { required: true, message: '请输入邮箱', trigger: 'blur' },
                        { type: 'string', min: 2, message: '邮箱至少输入2位', trigger: 'blur' },
                        { type: 'string', max: 255, message: '邮箱最多输入255位', trigger: 'blur' },
                        { validator: async (rule, value, callback) => {
                            let reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/
                            let result = reg.test(value);
                            this.disabledSendVCode = true;

                            if(!result){
                                callback(new Error('请输入正确的邮箱号'));
                                return;
                            }
                            result = await loginService.checkEmail(value);
                            if(!result){
                                callback(new Error('邮箱号已被占用'));
                                return;
                            }
                            this.disabledSendVCode = false;
                            callback();
                        }, trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '密码至少输入6位', trigger: 'blur' },
                        { type: 'string', max: 32, message: '密码最多输入32位', trigger: 'blur' }

                    ],
                    password2: [
                        { required: true, message: '请在此输入密码', trigger: 'blur' },

                        { validator: (rule, value, callback) => {
                            if(this.formData2.password !== value){
                                callback(new Error('两次密码不一致'));
                                return;
                            }
                            callback();
                        }, trigger: 'blur' }
                    ],
                    nickname: [
                        { required: true, message: '请输入昵称', trigger: 'blur' },
                        { type: 'string', min: 1, message: '昵称至少输入2位', trigger: 'blur' },
                        { type: 'string', max: 32, message: '昵称不能超过32个字符', trigger: 'blur' }

                    ],
                    vcode: [
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ],
                },
                formData2: {
                    nickname:"",
                    username:"",
                    account:"",
                    password:"",
                    password2:"",
                    vcode:"",
                    inviteCode:"",
                },
                sending: 0,
                disabledSendVCode: true,
                loading: false,
            }
        },
        mounted(){
        },
        methods:{
            open(type){
                this.show = true;
                this.disabledSendVCode = true;
                this.type = type;
                this.formData2.inviteCode = this.$route.query.inviteCode;
            },
            async sendVCode(account){

                if(this.sending > 1){
                    return;
                }
                loginService.sendVCode(account);
                this.$Message.success('验证码发送成功，请前往邮箱查看');

                this.sending = 60;
                this.iid = window.setInterval(() => {
                    if(--this.sending < 1){
                        window.clearInterval(this.iid);
                    }
                },1000);
            },
            register(){
                let {nickname,username,account,password,vcode,inviteCode} = this.formData2;
                let params = {nickname,username,account,password,vcode,inviteCode};

                let sub = async () => {
                    this.loading = true;
                    let result = await loginService.register(params);
                    this.loading = false;
                    if(!result){
                        return;
                    }
                    this.type = 1;
                    this.$Message.success('注册成功，请登录');
                    
                }
                this.$refs.registerForm.validate((valid) => {
                    if (valid) {
                        sub();
                    } 
                })
            },
            login(){
                let {account,password} = this.formData;
                let params = {account,password};
                let sub = async () => {
                    this.loading = true;
                    //ajax
                    let result = await loginService.login(params);
                    this.loading = false;
                    if(!result){
                        return;
                    }
                    this.$Message.success('登陆成功');
                    this.setLoginInfo(result);
                }
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        sub();
                    }
                })
            },
            async setLoginInfo(loginVO){
                sessionStorage.setItem("userId",loginVO.userId);
                sessionStorage.setItem("sk",loginVO.sk);
                let userInfo = await userService.get();
                sessionStorage.setItem("userInfo",JSON.stringify(userInfo));
                this.$emit("on-login-success",userInfo);
                this.show = false;
            },
            showa(){
                this.$refs.UserOKServiceModalRef.open()
            },
            showb(){
                this.$refs.UserOKPrivateModalRef.open()

            },
            openModal(){
                this.modal.show = true;
                this.modal.current = 0;
                this.modal.formData = {
                    account: "",
                    email: "",
                    password: "",
                    password2: "",
                    vcode: "",
                }
            },
            per(){
                this.modal.current -= 1;
            },
            next(){
                this.$refs.resetPwdForm.validate(async (valid) => {
                    if (valid) {
                        if(this.modal.current == 0){
                            this.modal.current += 1;
                            this.sendVCode(this.modal.formData.email)
                            return;
                        }

                        if(this.modal.current == 1){
                            this.loading = true;
                            let request = {
                                email: this.modal.formData.email,
                                vcode: this.modal.formData.vcode,
                                password: this.modal.formData.password
                            }
                            let result = await loginService.resetPwdByVcode(request);
                            this.loading = false;
                            if(result){
                                this.modal.current += 1;
                                return;
                            }
                        }


                    }
                })
            }
        }
    }
</script>